import type { ReactNode } from 'react';

import { cn } from '../lib/cn';

export type TMeterTone = 'accent' | 'danger' | 'motion' | 'success';

const FILL: Record<TMeterTone, string> = {
  accent: 'bg-accent',
  danger: 'bg-danger',
  motion: 'bg-motion',
  success: 'bg-success',
};

interface IMeterProps {
  value: number;
  tone?: TMeterTone;
  className?: string;
}

const clamp = (value: number) => Math.min(100, Math.max(0, value));

export const Meter = ({ value, tone = 'accent', className }: IMeterProps) => (
  <div className={cn('h-meter overflow-hidden rounded-meter bg-border-sunken', className)}>
    <span className={cn('block h-full', FILL[tone])} style={{ width: `${clamp(value)}%` }} />
  </div>
);

interface IMeterRowProps {
  tone: TMeterTone;
  label: ReactNode;
  value: number;
  count: ReactNode;
  className?: string;
}

export const MeterRow = ({ tone, label, value, count, className }: IMeterRowProps) => (
  <div className={cn('flex items-center gap-inset py-meter-pad', className)}>
    <span aria-hidden className={cn('size-dot shrink-0 rounded-full', FILL[tone])} />
    <span className="w-meter-label shrink-0 truncate text-data text-muted">{label}</span>
    <span className="h-meter-row grow overflow-hidden rounded-meter-row bg-border-sunken">
      <span className={cn('block h-full', FILL[tone])} style={{ width: `${clamp(value)}%` }} />
    </span>
    <span className="w-meter-count shrink-0 text-right font-mono text-data text-primary">
      {count}
    </span>
  </div>
);
